import React from "react";

const CustomerService = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-CustomerService"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-CustomerService"
      viewBox="0 0 512 512"
      width={_width}
      {...props}
    >
      <path d="M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z" />
    </svg>
  );
};

export default CustomerService;
